import { render, staticRenderFns } from "./CardFont.vue?vue&type=template&id=2170b4d0&scoped=true&"
import script from "./CardFont.vue?vue&type=script&lang=js&"
export * from "./CardFont.vue?vue&type=script&lang=js&"
import style0 from "./CardFont.vue?vue&type=style&index=0&id=2170b4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170b4d0",
  null
  
)

export default component.exports